import { render, staticRenderFns } from "./MarketplaceIcon.vue?vue&type=template&id=141af9c3&scoped=true&"
import script from "./MarketplaceIcon.vue?vue&type=script&lang=js&"
export * from "./MarketplaceIcon.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceIcon.vue?vue&type=style&index=0&id=141af9c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141af9c3",
  null
  
)

export default component.exports